<template>
  <div class="mb-3 mt-5">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('register.title') }}</h1>
      <register-form></register-form>
    </b-container>
  </div>
</template>

<script>
import RegisterForm from '../components/RegisterForm'
export default {
  name: 'Register',
  components: { RegisterForm }
}
</script>

<style scoped>

</style>
